import { Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IGroupOrderShareService } from "./groupOrderShare.facade";
import { WebShopService } from "../../services/webShop.service";
import { TableData, Table } from "../../services/IInHouseOrderService";
import { CoreLogService } from "../../services/log.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { WarningdialogComponent } from "../../modalDialogs";
import { Router } from "@angular/router";
import { CoreCOMService } from "../../services/com.service";
import { Client, ClientType } from "../../services/com/comEnvironmentClient";
import { base_environment } from "../../../../environments/environment.base";
import { custom_environment } from "../../../custom/environment";
import { env } from "../../../../environments/environment";

@Injectable()
export class GroupOrderShareService
  implements IGroupOrderShareService, OnDestroy {
  private _inHouseTableChangedSub: Subscription;
  private _inHouseTableClosedSub: Subscription;

  public groupLink: string;

  constructor(
    private _coreCOMService: CoreCOMService,
    private _inHouseOrderService: InHouseOrderService,
    private _webShopService: WebShopService,
    private _coreLogService: CoreLogService,
    private _bottomSheetHelperService: BottomSheetHelperService,
    private _router: Router
  ) {
    const me = this;

    me.groupLink = this.createGroupLink();

    // null damit kein unnötiger Abruf stattfindet
    me._inHouseOrderService
      .GetTable(null)
      .then((table) => {
        me.rebindInHouseTable(table);
      })
      .catch((error) => {
        me._coreLogService.error(
          "GroupOrderShareService.constructor",
          "inHouseOrderService.GetTable catch",
          error
        );
      });

    me._inHouseTableChangedSub =
      me._inHouseOrderService.ObserveOnTableChanged.subscribe(async (_) => {
        const table = await me._inHouseOrderService.GetTable(null); // null damit kein unnötiger Abruf stattfindet
        me.rebindInHouseTable(table);
      });

    me._inHouseTableClosedSub =
      me._inHouseOrderService.ObserveOnTableClosedChanged.subscribe((_) => {
        me.OpenWarningLinkExpired();
      });
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;

    if (me._inHouseTableChangedSub) me._inHouseTableChangedSub.unsubscribe();
    if (me._inHouseTableClosedSub) me._inHouseTableClosedSub.unsubscribe();
  }

  /** bindet die Werte welche vom aktuellen Tisch Abhängig sind */
  private async rebindInHouseTable(table: Table): Promise<void> {
    const me = this;
    const webshoSetting =
      await me._webShopService.getWebshopSettingsDataModel();
    let participants_per_group = 0;
    if (
      webshoSetting.in_house_order &&
      webshoSetting.in_house_order.grouporder
    ) {
      participants_per_group =
        webshoSetting.in_house_order.grouporder.participants_per_group;
    }
    me._setGroupIsFull(
      table.yasTable.customers.length >= participants_per_group
    );
  }

  /** aktualisiert status ob gruppe voll ist */
  private _setGroupIsFull(value: boolean): void {
    const me = this;
    if (me._groupIsFull != value) {
      me._groupIsFull = value;
      me._groupIsFullSubject.next(value);
    }
  }
  /** use _setGroupIsFull */
  private _groupIsFull: boolean = false;
  private _groupIsFullSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  get groupIsFull$(): Observable<boolean> {
    return this._groupIsFullSubject.asObservable();
  }

  /** Warning dialog: table / group closed */
  private OpenWarningLinkExpired() {
    const me = this;
    const warningButtomSheet = me._bottomSheetHelperService.open(
      WarningdialogComponent,
      {
        data: {
          title: "phGroupOrder_LinkExpired_Title",
          content: "phGroupOrder_LinkExpired_SubText",
          btnLabel: "phGroupOrder_LinkExpired_Btn",
        },
        panelClass: "mat-bottom-sheet-container-medium",
      }
    );
    warningButtomSheet.afterDismissed().subscribe((result) => {
      if (result) {
        me._router.navigate(["/menuservice"]);
      }
    });
  }

  private createGroupLink(): string {
    const origin = this.determineOrigin();
    const site = "group/";
    const groupcode = this._inHouseOrderService.GroupCode;
    return `${origin}${site}${groupcode}`;
  }

  private determineOrigin() {
    switch (this._coreCOMService.environment.client.type) {
      case ClientType.ios:
      case ClientType.android:
        return env.YourAppServer.BaseURI;
      default:
        return location.origin + "/";
    }
  }
}
